












































import Component, { mixins } from "vue-class-component";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import GoBack from "@/components/GoBack.vue";
import PageTitle from "@/components/PageTitle.vue";
import PageSubTitle from "@/components/PageSubTitle.vue";
import WithCurrency from "@/mixins/WithCurrency";
import WithSystemSettings from "@/mixins/WithSystemSettings";
import BaseGrid from "@/components/BaseGrid.vue";
import BlockCurrency from "./components/BlockCurrency.vue";
import BlockCurrencyAdd from "./components/BlockCurrencyAdd.vue";
import ModalContainer from "@/components/ModalContainer.vue";
import BlockMainCurrency from "@/views/PageSettingsCurrencies/components/BlockMainCurrency.vue";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import { InputSystemSettings } from "@teacherskaya/api-provider/dist/api/SystemSettingsProvider";
import { Currency, InputCurrencyCreate, InputCurrencyUpdate } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({
  name: "PageSettingsCurrencies",
  components: {
    WrapperCheckAuthorities,
    BlockMainCurrency,
    BlockCurrencyAdd,
    BlockCurrency,
    BaseGrid,
    PageSubTitle,
    PageTitle,
    GoBack,
    ModalContainer,
    BasePageOneColumn,
  },
})
export default class PageSettingsCurrencies extends mixins(WithCurrency, WithSystemSettings, WithLoadingStatus) {
  public isLoading: boolean = true;

  public currencyList: Currency[] = [];

  public showCreate: boolean = false;

  get mainCurrency() {
    return this.systemSettingsState.mainCurrency;
  }

  public updateMainCurrency(data: InputSystemSettings) {
    this.systemSettingsUpdate({ data });
  }

  public create(data: InputCurrencyCreate, vm: any) {
    this.currencyCreate({ data }).then((response: Currency) => {
      this.currencyList = [response, ...this.currencyList];
      this.showCreate = false;
      vm.values = {};
    });
  }

  public update(data: InputCurrencyUpdate) {
    this.currencyUpdate({ data }).then((response: Currency) => {
      this.currencyList = this.currencyList.map(item => {
        if (item.name === response.name) return response;
        return item;
      });
    });
  }

  public getCurrencyData() {
    return this.currencyFindAll().then((response: Currency[]) => {
      this.currencyList = response;
    });
  }

  public deleteItem(name: string) {
    this.currencyDelete({ name }).then((response: boolean) => {
      if (response) this.currencyList = this.currencyList.filter(i => i.name !== name);
    });
  }

  public created() {
    this.loadingStatusShow([this.getCurrencyData(), this.systemSettingsGet()]).then(() => {
      this.isLoading = false;
    });
  }
}
